<template>
    <div class="info-bathymetry-container">       
        <div v-if="bathymetryCampaignSelected != null">
          <div class="panel-content-title">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].name }}
          </div>
          <div class="panel-content-header">
            Fecha
          </div>
          <div class="panel-content-line">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].date }}
          </div>
          <div class="panel-content-header">
            Código
          </div>
          <div class="panel-content-line">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].code }}
          </div>
          <div class="panel-content-header">
            Abstract
          </div>
          <div class="panel-content-line">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].abstract }}
          </div>
          <div class="panel-content-header">
            Descripción
          </div>
          <div class="panel-content-line">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].description }}
          </div>
          <div class="panel-content-header">
            Localización
          </div>
          <div class="panel-content-line">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].location }}
          </div>
          <div class="panel-content-header">
            Objetivo
          </div>
          <div class="panel-content-line">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].goal }}
          </div>
          <div class="panel-content-header">
            <h5>Datos de la campaña</h5>
            <div class="input-group ">
                <select id="campaign" class="custom-select" v-model="bathymetryCampaignDataSelected">
                    <option
                      v-for="(campaignData, index) in bathymetryCampaignsList[bathymetryCampaignSelected].bathymetryCampaignData"
                      :key="index"
                      :label="campaignData.name"
                      :value="index">
                    </option>
                </select>
              </div>
          </div>
          <div class="panel-content-header">
            Descripción
          </div>
          <div class="panel-content-line">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].bathymetryCampaignData[bathymetryCampaignDataSelected].description }}
          </div>
          <div class="panel-content-header">
              Comentarios
          </div>
          <div class="panel-content-line">
            {{ bathymetryCampaignsList[bathymetryCampaignSelected].bathymetryCampaignData[bathymetryCampaignDataSelected].comments }}
          </div>
          <div class="panel-content-header">
            Fecha
          </div>
          <div class="panel-content-line">
             {{ bathymetryCampaignsList[bathymetryCampaignSelected].bathymetryCampaignData[bathymetryCampaignDataSelected].date }}
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'infoPanelBathymetry',
    data: function () {
        return {
          bathymetryCampaignDataSelected: 0
        }
    },
    computed: {
      bathymetryCampaignSelected: {
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaignSelected }
      },
      bathymetryCampaignsList: {
          set (campaignsList) { this.$store.dispatch('changeBathymetryCampaignsList', {bathymetryCampaignsList: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaignsList }
      },
    }
  }
</script>

<style scoped>
  .info-bathymetry-container {
    width: 100%;
    padding: 0px 10px 10px 18px;
  }
  .global-bathymetry-container {
    display: flex;
    flex-direction: column;
  }
  .panel-content-line{
    font-size: small;
    line-height: 80%;
    margin-bottom: 0.8rem;
  }
  .panel-content-header{
    font-size: small;
    line-height: 100%;
    font-weight: 800;
    margin-bottom: 0.5rem;
  }
  .panel-content-title{
    font-weight: 800;
    margin-bottom: 0.5rem;
    color: #00A7E3;
  }
</style>


// WEBPACK FOOTER //
// src/components/map/InfoPanelBathymetry.vue